import React, {useState, useEffect, useRef} from 'react'
import './style.css'

export default function Bayar() {
    const [timerHouse, setTimerHouse] = useState('0')
    const [timerMinuts, setTimerMinuts] = useState('0')
    const [timerSecons, setTimerSecons] = useState('0')

    let interval = useRef()

    const startTimer = () => {
        const countDownDate = new Date('september 11, 2021 00:00:00').getTime()

        interval = setInterval(() => {
            const now = new Date().getTime()
            const distance = countDownDate - now;

            const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
            const minuts = Math.floor((distance % (1000 * 60 * 60 )) / (1000 * 60 ))
            const secons = Math.floor((distance % (1000 * 60 )) / 1000)

            if(distance < 0) {
                clearInterval(interval.current)
            } else {
                setTimerHouse(hours)
                setTimerMinuts(minuts)
                setTimerSecons(secons)
            }
        }, 1000)
    }

    useEffect(() => {
        startTimer();
    })

    return (
            <div className="componenet-bayar">
                <div>
                    <div className="time-later-product">
                    <h3>Menunggu untuk Di bayar</h3>
                    <p>Batas Pembayaran</p>
                        <div className="timer">
                            <h2>{timerHouse}<span>Jam</span> :</h2>
                            <h2>{timerMinuts}<span>Menit</span> :</h2>
                            <h2>{timerSecons}<span>Detik</span></h2>
                        </div>
                        <p>Kode Pemesanan : 192401sf9149s</p>
                        <h3>Silakan segera menyelesaikan pembayaran anda</h3>
                    </div>
                </div>
                <div className="pembayaran">
                    <h6>Belum Dibayar</h6>
                    <p>Total yang harus dibayar</p>
                    <h2>Rp. 160.000</h2>
                    <div className="group-tombol">
                        <button type="button">Hubungi Toko</button>
                        <button type="button">Bayar</button>
                    </div>
                </div>
            </div>
    )
}
